import { CSSProperties, useContext, KeyboardEvent } from "react";
import AutosizeInput from "react-input-autosize";
import { FormContext } from "../../../context";
import cssStyles from "./InlineInput.module.scss";
import { PropsWithDataTest } from "../../../types";

interface Props extends PropsWithDataTest {
  name: string;
  onBlur?: () => void;
  onKeyUp?: (e: KeyboardEvent<HTMLDivElement>) => void;
  autoFocus?: boolean;
  defaultValue?: string;
  inputStyle?: CSSProperties;
  styles?: CSSProperties;
  maxWidth?: string;
}

export const InlineInput = ({
  name,
  autoFocus,
  defaultValue,
  styles,
  maxWidth,
  "data-test": dataTest,
  ...props
}: Props) => {
  const { formik } = useContext(FormContext);

  return (
    <AutosizeInput
      {...props}
      style={{ ...styles, maxWidth }}
      autoFocus={autoFocus}
      inputStyle={{ ...props.inputStyle, maxWidth: maxWidth }}
      className={cssStyles.input}
      data-test={dataTest}
      value={formik?.values[name] ?? defaultValue}
      onChange={(event) => {
        formik?.setFieldValue(name, event.target.value);
      }}
      onFocus={(e) => e.target.select()}
      onBlur={props.onBlur}
      onKeyUp={props.onKeyUp}
    />
  );
};
